<template>
  <div class="contact-content-wrapper">
    <div class="form-group row">
      <ContentHeadline class="col-12 ch-contact-first-question" v-if="step.firstQuestion">{{ step.firstQuestion }}</ContentHeadline>
      <div class="col-12 col-lg-6">
        <div class="sr-only visually-hidden-focusable">
          <label for="anrede">Anrede</label>
        </div>
        <input type="text"
               id="anrede"
               placeholder="Anrede (optional)"
               autocomplete="honorific-prefix"
               list="anrede_list"
               class="form-control"
               :class="{ 'is-invalid': validation.salutation.hasError }"
               v-model="step.salutation"
               @blur="validateSalutation()"
        >
        <datalist id="anrede_list">
          <option name="Frau">Frau</option>
          <option name="Herr">Herr</option>
          <option name="Frau">Frau Dr.</option>
          <option name="Herr">Herr Dr.</option>
        </datalist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12 col-lg-6 mb-3 m-lg-0">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_firstname" class="form-label">Vorname</label>
        </div>
        <input type="text"
               id="mf6_firstname"
               required
               autocomplete="given-name"
               placeholder="Vorname"
               v-model="step.firstName"
               class="form-control"
               :class="{ 'is-invalid': validation.firstName.hasError }"
               @blur="validateFirstName()"
        >
        <div class="invalid-feedback">
          {{ validation.firstName.message }}
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_lastname">Nachname</label>
        </div>
        <input type="text"
               id="mf6_lastname"
               required
               autocomplete="family-name"
               placeholder="Nachname"
               v-model="step.lastName"
               class="form-control"
               :class="{ 'is-invalid': validation.lastName.hasError }"
               @blur="validateLastName()"
        >
        <div class="invalid-feedback">
          {{ validation.lastName.message }}
        </div>
      </div>

    </div>
    <div class="form-group row" :style="idcpStyle">
      <div class="col-12 col-lg-6 mb-3 m-lg-0">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_idcp_name_udpbjnwa">Vorname 2</label>
        </div>
        <input type="text"
               id="mf6_idcp_name_udpbjnwa"
               autocomplete="off"
               role="presentation"
               placeholder="leer lassen"
               v-model="step.idcpNameUdpbjnwa"
               class="form-control"
        >
      </div>
      <div class="col-12 col-lg-6">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_idcp_name_emnyjvxh">Nachname 2</label>
        </div>
        <input type="text"
               id="mf6_idcp_name_emnyjvxh"
               autocomplete="off"
               placeholder="nicht ausfüllen"
               role="presentation"
               v-model="step.idcpNameEmnyjvxh"
               class="form-control"
        >
      </div>
    </div>

    <div class="form-group row" v-show="step.mandatory.includes('address') === true">
      <div class="col-12">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_street">Straße und Hausnummer</label>
        </div>
        <input type="text"
               id="mf6_street"
               required
               v-model="step.street"
               @blur="validateStreet()"
               placeholder="Straße und Hausnummer"
               class="form-control"
               :class="{ 'is-invalid': validation.street.hasError}"
               autocomplete="address-line1"
        >
        <div class="invalid-feedback">
          {{ validation.street.message }}
        </div>
      </div>
    </div>

    <div class="form-group row" v-show="step.mandatory.includes('address') === true">
      <div class="col-12 col-lg-4 mb-3 m-lg-0">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_zip">Postleitzahl</label>
        </div>
        <input type="text"
               id="mf6_zip"
               required
               v-model="step.zip"
               @blur="validateZip()"
               placeholder="PLZ"
               class="form-control"
               :class="{ 'is-invalid': validation.zip.hasError}"
               autocomplete="postal-code"
        >
        <div class="invalid-feedback">
          {{ validation.zip.message }}
        </div>
      </div>
      <div class="col-12 col-lg-8">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_place">Ort</label>
        </div>
        <input type="text"
               id="mf6_place"
               required
               placeholder="Ort"
               autocomplete="address-level2"
               class="form-control"
               :class="{ 'is-invalid': validation.zip.hasError}"
               v-model="step.place"
               @blur="validatePlace()"
        >
        <div class="invalid-feedback">
          {{ validation.place.message }}
        </div>
      </div>
    </div>

    <div class="form-group row" v-show="step.mandatory.includes('address') === true">
      <div class="col-12">
        <div class="sr-only visually-hidden-focusable">
          <label for="mf6_country">Land</label>
        </div>
        <input type="text"
               id="mf6_country"
               required
               placeholder="Land"
               autocomplete="country-name"
               v-model="step.country"
               class="form-control"
               :class="{ 'is-invalid': validation.country.hasError}"
               @blur="validateCountry()"
               list="land_list"
        >
        <div class="invalid-feedback">
          {{ validation.country.message }}
        </div>
        <datalist id="land_list">
          <option value="Deutschland">Deutschland</option>
          <option value="Österreich">Österreich</option>
          <option value="Schweiz">Schweiz</option>

          <option value="Belgien">Belgien</option>
          <option value="Dänemark">Dänemark</option>
          <option value="Frankreich">Frankreich</option>
          <option value="Groß Britanien">Groß Britanien</option>
          <option value="Luxemburg">Luxemburg</option>
          <option value="Italien">Italien</option>
          <option value="Kanada">Kanada</option>
          <option value="Niederlande">Niederlande</option>
          <option value="Polen">Polen</option>
          <option value="Schweden">Schweden</option>
          <option value="Spanien">Spanien</option>
          <option value="Tschechien">Tschechien</option>
          <option value="USA">USA</option>
        </datalist>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-12">
        <div class="field-wrapper sr-only visually-hidden-focusable">
          <label for="mf6_email">E-Mail</label>
        </div>
        <input type="email"
               id="mf6_email"
               :required="mailRequired"
               :placeholder="mailRequired ? 'E-Mail' : 'E-Mail (optional)'"
               class="form-control"
               :class="{ 'is-invalid': validation.email.hasError}"
               v-model="step.email"
               @blur="validateMail()"
        >
        <div class="invalid-feedback">
          {{ validation.email.message }}
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-lg-6 mb-3 m-lg-0">
            <div class="sr-only visually-hidden-focusable">
              <label for="tel_priv">Telefon</label>
            </div>
            <input type="tel"
                   id="tel_priv"
                   autocomplete="tel"
                   :required="phoneRequired"
                   :placeholder="phoneRequired ? 'Telefon' : 'Telefon (optional)'"
                   v-model="step.phone"
                   @blur="validatePhone()"
                   class="form-control"
                   :class="{ 'is-invalid': validation.phone.hasError}"
            >
            <div class="invalid-feedback">
              {{ validation.phone.message }}
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="sr-only visually-hidden-focusable">
              <label for="mf6_availability">Angaben zur Erreichbarkeit (optional)</label>
            </div>
            <input type="text"
                   id="mf6_availability"
                   placeholder="Angaben zur Erreichbarkeit (optional)"
                   list="erreichbarkeit_list"
                   class="form-control"
                   :class="{ 'is-invalid': validation.availability.hasError}"
                   v-model="step.availability"
                   :disabled="step.phone == ''"
                   @blur="validatePhone()"
            >
            <div class="invalid-feedback">
              {{ validation.availability.message }}
            </div>
            <datalist id="erreichbarkeit_list">
              <option>Abends erreichbar</option>
              <option>Vormittags erreichbar</option>
              <option>Immer erreichbar</option>
            </datalist>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row justify-content-end mt-5 mb-4">
      <div class="col-12 col-md-4 d-none d-md-flex">
        <a href="#back" @click.prevent="clickPrev" class="btn-back mt-2 ms-4 pl-2" tabindex="0">&lt; zurück</a>
      </div>
      <div class="col-md-4 d-none d-md-flex"></div>
      <div class="col-12 col-md-4">
        <div class="alert alert-warning" role="alert" v-show="showNextDisabledHint">
          {{ $store.state.i18n.btnNextDisabledText }}
        </div>
        <button type="button" @click="clickNext" class="btn btn-dark btn-block next">{{ $store.state.i18n.next }}
        </button>
        <div class="btn-subtext text-center pt-1">{{ $store.state.i18n.btnNextSubtext }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ContentHeadline from "./partials/ContentHeadline.vue";

export default {
  components: {ContentHeadline},
  props: ['step'],
  data() {
    return {
      showNextDisabledHint: false,
      validation: {
        salutation: {hasError: false, message: 'Eingabe unvollständig/ungültig: Anrede'},
        firstName: {hasError: false, message: 'Bitte geben Sie Ihren Vornamen ein.'},
        lastName: {hasError: false, message: 'Bitte geben Sie Ihren Nachnamen ein.'},
        email: {hasError: false, message: 'Bitte geben Sie Ihre korrekte E-Mail ein.'},
        phone: {hasError: false, message: 'Bitte geben Sie Ihre Telefonnummer ein.'},
        street: {hasError: false, message: 'Bitte geben Sie Ihre Straße ein.'},
        zip: {hasError: false, message: 'Bitte geben Sie Ihre Postleitzahl ein.'},
        place: {hasError: false, message: 'Bitte geben Sie Ihren Ort ein.'},
        country: {hasError: false, message: 'Bitte geben Sie Ihre Land ein.'},
        availability: {hasError: false, message: 'Bitte geben Sie Ihre Verfügbarkeit an.'}
      },
      showErrors: false,
      mailRequired: this.step.mandatory.includes('email'),
      phoneRequired: this.step.mandatory.includes('phone'),
    }
  },
  computed: {
    idcpStyle() {
      return (this.step.idcpNameUdpbjnwa || this.step.idcpNameEmnyjvxh) ? '' : 'display:none'
    },
  },
  created() {
    if (this.step.mandatory.includes('email')) {
      this.mail_checkbox = true;
    }
    if (this.step.mandatory.includes('phone')) {
      this.phone_checkbox = true;
    }
    if (this.step.mandatory.includes('address')) {
      this.address_checkbox = true;
    }
  },
  methods: {
    setError(type) {
      this.validation[type].hasError = true;
    },
    removeError(type) {
      this.showNextDisabledHint = false;
      this.validation[type].hasError = false;
    },
    handleUserData() {
      this.showNextDisabledHint = false;
      this.step.clearSummary();
      this.$store.commit('updateUserInput', {
        name: 'anrede',
        module: this.step.type,
        input: this.step.salutation
      });
      this.$store.commit('updateUserInput', {
        name: 'vorname',
        module: this.step.type,
        input: this.step.firstName
      });
      this.$store.commit('updateUserInput', {
        name: 'name',
        module: this.step.type,
        input: this.step.lastName
      });
      this.$store.commit('updateUserInput', {
        name: 'idcp_name_udpbjnwa',
        module: this.step.type,
        input: this.step.idcpNameUdpbjnwa
      });
      this.$store.commit('updateUserInput', {
        name: 'idcp_name_emnyjvxh',
        module: this.step.type,
        input: this.step.idcpNameEmnyjvxh
      });
      let summaryText = this.step.salutation + ' ' + this.step.firstName + ' ' + this.step.lastName;
      summaryText = summaryText + "\n " + (this.step.idcpNameUdpbjnwa || '') + ' ' + (this.step.idcpNameEmnyjvxh || '');

      if (this.address_checkbox) {
        this.$store.commit('updateUserInput', {
          name: 'strasse',
          module: this.step.type,
          input: this.step.street
        });
        this.$store.commit('updateUserInput', {name: 'plz', module: this.step.type, input: this.step.zip});
        this.$store.commit('updateUserInput', {
          name: 'ort',
          module: this.step.type,
          input: this.step.place
        });
        this.$store.commit('updateUserInput', {
          name: 'land',
          module: this.step.type,
          input: this.step.country
        });
        summaryText += '<br>' + this.step.street;
        summaryText += '<br>' + this.step.zip + ' ' + this.step.place + ', ' + this.step.country;
      }

      this.$store.commit('updateUserInput', {
        name: 'email',
        module: this.step.type,
        input: this.step.email
      });
      summaryText += '<br> E-Mail: ' + this.step.email;

      this.$store.commit('updateUserInput', {
        name: 'tel_priv',
        module: this.step.type,
        input: this.step.phone
      });
      this.$store.commit('updateUserInput', {
        name: 'erreichbarkeit',
        module: this.step.type,
        input: this.step.availability
      });
      if (this.step.phone !== "") {
        summaryText += '<br> Telefon: ' + this.step.phone;
        if (this.step.availability !== "") {
          summaryText += ', ' + this.step.availability
        }
      }

      this.step.addToSummary({label: 'Kontaktdaten', text: summaryText});
    },
    validateSalutation() {
      // if (this.step.salutation === '') {
      //     this.setError('salutation');
      //     return false;
      // }
      // this.removeError('salutation');
      return true;
    },
    validateFirstName() {
      if (this.step.firstName === '') {
        this.setError('firstName');
        return false;
      }
      this.removeError('firstName');
      return true;
    },
    validateLastName() {
      if (this.step.lastName === '') {
        this.setError('lastName');
        return false;
      }
      this.removeError('lastName');
      return true;
    },
    // validateUser() {
    //     return this.validateSalutation() && this.validateFirstName() && this.validateLastName();
    // },
    validateMail() {
      if (this.mail_checkbox) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (this.step.email === '' || !re.test(this.step.email)) {
          this.setError('email');
          return false;
        }
        let url = '';
        // url += 'http://localhost:3010';
        url += 'https://anfrage.mvp.de/v3';
        url += '/api/mail_addresses/auto/validate';
        const searchParams = new URLSearchParams();
        searchParams.append("mail_address[address]", this.step.email)
        url += `?${searchParams.toString()}`
        axios.get(url)
            .then(() => {
              this.removeError('email')
            })
            .catch(() => {
              this.setError('email');
            });
      }
      this.removeError('email');
      return true;
    },
    validatePhone() {
      if (this.phone_checkbox) {
        if (this.step.phone === '') {
          this.setError('phone');
          return false;
        }
      }
      this.removeError('availability');
      this.removeError('phone');

      return true;
    },
    validateStreet() {
      if (this.step.street === '') {
        this.setError('street');
        return false;
      }
      this.removeError('street');
      return true;
    },
    validateZip() {
      if (this.step.zip === '') {
        this.setError('zip');
        return false;
      }
      this.removeError('zip');
      return true;
    },
    validatePlace() {
      if (this.step.zip === '') {
        this.setError('zip');
        return false;
      }
      this.removeError('zip');
      return true;
    },
    validateCountry() {
      if (this.step.country === '') {
        this.setError('country');
        return false;
      }
      this.removeError('country');
      return true
    },
    validateAddress() {
      if (this.address_checkbox) {
        return this.validateStreet() && this.validateZip() && this.validatePlace() && this.validateCountry();
      }
      return true;
    },
    validate(e) {
      this.showNextDisabledHint = false;
      this.step.wasValidated = true;

      const validations = [
        // this.validateUser(),
        this.validateSalutation(),
        this.validateFirstName(),
        this.validateLastName(),
        this.validateAddress(),
        this.validateMail(),
        this.validatePhone(),
      ];
      const allValidationSucceeded = validations.every(v => v);
      if (allValidationSucceeded) {
        this.handleUserData();
      }
      return allValidationSucceeded;
    },

    clickNext(e) {
      if (this.validate()) {
        this.$store.commit('setNextStep');
      } else {
        this.showNextDisabledHint = true;
      }
    },
    clickPrev(e) {
      this.$store.commit('setLastStep');
    },
  }
}
</script>